export class DeviceView {
}
